import React from 'react';
import { core as Core } from 'zingchart-react';

import commonChartConfig from "components/common/charts/commonchartconfig"
/*
This component is used in
components/pages/comparison/charts/dailychart/index.jsx
components/pages/comparison/charts/totalchart/index.jsx
components/pages/stats/dailyoccupancy/pianochartcontainer.jsx
components/pages/stats/totaloccupancy/index.jsx
components/pages/stats/totaloccupancy/linechartcontainer.jsx
*/
const LineChart = (props) => {
    var myConfig = Object.assign({}, commonChartConfig, {

        type: "line",
        plotarea: {
            marginTop: '10px',
            marginRight: '50px',
            marginLeft: '40px',
            backgroundColor: "#f6f7fa"
        },
        legend: {
            layout: "float",
            backgroundColor: "none",
            borderWidth: 0,
            shadow: 0,
            align: "center",
            adjustLayout: true,
            item: {
                padding: 7,
                marginRight: 17,
                cursor: "hand"
            }
        },
        scaleX: {
            labels: props.stats.labels,
            minorTicks: 0
        },
        scaleY: {
            values: "0:100:20",
            lineColor: "#f6f7f8",
            shadow: 0,
            format: "%v%",
            guide: {
                lineStyle: "dashed",
                lineColor: "white"
            },
            markers: [
                {
                    type: "area",
                    range: [80, 100],
                    lineColor: "#e39199",
                    lineWidth: 2

                },
                {
                    type: "area",
                    range: [0, 20],
                    lineColor: "#faf8f9",
                    lineWidth: 2

                }
            ],
            minorTicks: 0,
            thousandsSeparator: ","
        },
        crosshairX: {
            lineColor: "#efefef",
            plotLabel: {
                borderRadius: "5px",
                borderWidth: "1px",
                borderColor: "#f6f7f8",
                padding: "10px",
                fontWeight: "bold"
            },
            scaleLabel: {
                fontColor: "#000",
                backgroundColor: "#f6f7fa",
                borderRadius: "5px"
            }
        },
        tooltip: {
            visible: false
        },
        plot: {
            highlight: true,
            tooltipText: "%t views: %v<br>%k",
            shadow: 0,
            lineWidth: "2px",
            marker: {
                type: "circle",
                size: 1.6
            },
            highlightState: {
                lineWidth: 3
            }
        },
        series: [
            {
                values: props.stats.peaks,
                text: props.first || "Peak",
                lineColor: "#60aff4",
                lineWidth: 5,
                legendItem: {
                    backgroundColor: "#60aff4",
                    borderRadius: 5,
                    fontColor: "white",
                    fontSize: "16px"
                },
                legendMarker: {
                    visible: false
                },
                marker: {
                    backgroundColor: "#60aff4",
                    borderWidth: 0,
                    shadow: 0,
                    borderColor: "#69dbf1"
                },
                highlightMarker: {
                    size: 5,
                    backgroundColor: "#60aff4"
                }
            },
            {
                values: props.stats.avgs,
                text: props.second || "Average",
                lineColor: "#3cb449",
                legendItem: {
                    backgroundColor: "#3cb449",
                    borderRadius: 5,
                    fontColor: "white",
                    fontSize: "16px"
                },
                lineWidth: 5,
                legendMarker: {
                    visible: false
                },
                marker: {
                    backgroundColor: "#3cb449",
                    borderwidth: 0,
                    shadow: 0,
                    borderColor: "#3cb449"
                },
                highlightMarker: {
                    size: 5,
                    backgroundColor: "#3cb449"
                }
            }
        ]
    });
    return (
        <React.Fragment>
            <Core id={props.id} data={myConfig} height="450px" width="100%" />
        </React.Fragment>
    );
}
export default LineChart


// WEBPACK FOOTER //
// ./src/components/common/charts/linechart.jsx